import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PriorityItemCard from 'Components/ComponentLibrary/Molecules/PriorityItemCard';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { hasRelationship } from 'Helpers/Affordances';
import fr from 'facet-rest';
import Text from 'Components/ComponentLibrary/Atoms/Text';

const styles = (theme) => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  margin: {
    marginBottom: theme.spacing(2),
  },
});

const PriorityCardList = ({
  className, classes, items, refetchItems, onClickItem,
}) => (
  <div className={classNames(className, classes.root)}>
    {items.map(resource => {
      let errorText;
      let onRaisePriority;
      if (hasRelationship(resource, fr.relationships.raisePriority.name)) {
        onRaisePriority = async () => {
          try {
            const next = await resource.relationship(fr.relationships.raisePriority.name).link('related').post({}, { deprecatedAllowAlterOfRelation: true });
            refetchItems(next);
          } catch (e) {
            errorText = 'Raise Priority Failed!';
          }
        };
      }
      let onLowerPriority;
      if (hasRelationship(resource, fr.relationships.lowerPriority.name)) {
        onLowerPriority = async () => {
          try {
            const next = await resource.relationship(fr.relationships.lowerPriority.name).link('related').post({}, { deprecatedAllowAlterOfRelation: true });
            refetchItems(next);
          } catch (e) {
            errorText = 'Lower Priority Failed!';
          }
        };
      }
      let onCardClick;
      if (hasRelationship(resource, fr.relationships.item.name)) {
        onCardClick = async () => {
          try {
            const next = await resource.relationship(fr.relationships.item.name).link('related').get();
            onClickItem(next);
          } catch (e) {
            errorText = 'Failed to Enter Strategy Setup!';
          }
        };
      }

      return (
        <>
          <PriorityItemCard
            className={classes.margin}
            key={resource.id()}
            name={resource.attr('label')}
            description={resource.attr('subLabel')}
            onRaisePriority={onRaisePriority}
            onLowerPriority={onLowerPriority}
            onClick={onCardClick}
          />
          {errorText && (
            <Text text={errorText} weight={'bold'} variant={'fineprint'} align={'left'} color={'error'} />
          )}
        </>
      );
    })}
  </div>
);

PriorityCardList.defaultProps = {
  items: [],
  className: null,
  onClickItem: undefined,
};

PriorityCardList.propTypes = {
  items: PropTypes.array,
  classes: PropTypes.array.isRequired,
  className: PropTypes.string,
  refetchItems: PropTypes.func.isRequired,
  onClickItem: PropTypes.func,
};

export default withStyles(styles)(PriorityCardList);
